export default "__VITE_ASSET__BBS$BAUQ__"